import { render, staticRenderFns } from "./BackTestChart.vue?vue&type=template&id=4dd7c9a8&scoped=true&"
import script from "./BackTestChart.vue?vue&type=script&lang=js&"
export * from "./BackTestChart.vue?vue&type=script&lang=js&"
import style0 from "./BackTestChart.vue?vue&type=style&index=0&id=4dd7c9a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd7c9a8",
  null
  
)

export default component.exports